import React from 'react';
import { formatText, HtmlText } from 'core/i18n';
import { DOCUMENT_TYPES } from 'constants/documents';
import { documentsAcceptedContentMap } from '../../contentMaps';
import { NO_ACTIVITY } from 'constants/userProfile';
import { getReferenceCodeByCountry } from 'utilities/multiLanguageHelper';

const DocumentSection = ({ documents }) => {
    return (
        <ul>
            {documents.map(({ document, time }) => (
                <li key={document}>
                    <p>
                        {HtmlText(formatText(document))}
                        {time && (
                            <span className="upload-documentation-modal-acceptedDocuments-time">
                                {formatText(time)}
                            </span>
                        )}
                    </p>
                </li>
            ))}
        </ul>
    );
};

const ModalContent = ({ conditions, documents }) => (
    <>
        <div className="upload-documentation-modal-conditions">
            <div className="upload-documentation-modal-acceptedDocuments-title">
                <i className="icons icons--icon-information-dialog"></i>
                {formatText('uploads-conditions')}
            </div>
            {conditions.map(condition => (
                <div key={condition}>
                    <p>
                        <i className="icons icons--icon-success-green-check"></i>
                        {HtmlText(formatText(condition))}
                    </p>
                </div>
            ))}
        </div>
        <div className="upload-documentation-modal-acceptedDocuments">
            <div className="upload-documentation-modal-acceptedDocuments-title">
                <i className="icons icons--icon-success-green-check"></i>
                {formatText('uploads-documentsAccepted')}
            </div>
            <DocumentSection documents={documents} />
        </div>
    </>
);

export const ModalWithAcceptedDocumentsContent = ({ documentType, accountType, profession }) => {
    if (!documentsAcceptedContentMap[documentType]) return null;

    if (documentType === DOCUMENT_TYPES.DAAL) {
        if (accountType === NO_ACTIVITY) {
            return (
                <ModalContent
                    {...documentsAcceptedContentMap[documentType][accountType][profession][
                        getReferenceCodeByCountry().toUpperCase()
                    ]}
                />
            );
        }

        return <ModalContent {...documentsAcceptedContentMap[documentType][accountType]} />;
    }

    return <ModalContent {...documentsAcceptedContentMap[documentType]} />;
};
